import type { EventHandler, SyntheticEvent } from 'react';

const combineHandlers =
  <T extends SyntheticEvent>(
    ...handlers: (EventHandler<T> | undefined)[]
  ): EventHandler<T> =>
  (e) =>
    handlers.forEach((handler) => handler && handler(e));

export default combineHandlers;
